import React from "react"
import portalLayer1 from "../themes/portalLayer1";
import portalLayer2 from "../themes/portalLayer2";
import portalLayer3 from "../themes/portalLayer3";
import weatherBubbles from "../themes/weatherBubbles";

export default function About(props){

    
    const icons = () => {

        return weatherBubbles.map((item,index)=>{
            const Layer1 = () => {
                let cssStyle;
                const indexIcon = item.icon;
                portalLayer1.forEach((thing1) => {
                     if (thing1.icon === indexIcon){
                        cssStyle = thing1.style;
                    }
                })
                return cssStyle;
            }
        
            const Layer2 = () => {
                let cssStyle2;
                const indexIcon = item.icon;
                const indexDesc = item.description;
                portalLayer2.forEach((thing2)=> {
                    if (thing2.description === indexDesc && thing2.icon === indexIcon){
                        cssStyle2 = thing2.style;
                        return cssStyle2;
                    }
                })
                return cssStyle2;
            }
        
            const Layer3 = () => {
                let cssStyle3;
                const indexIcon = item.icon;
                portalLayer3.forEach((thing3)=>{
                    if (thing3.icon === indexIcon){
                        cssStyle3 = thing3.style;
                        return cssStyle3;
                    }
                })
                return cssStyle3;
            }

            return (
                <div key={index} className="bubble-icon">
                    <p className="bubble-text">{item.title}</p>
                    <div className="bubble-image" style={{background: item.background}}>
                        <div id="bubble-image_1" style={Layer1()}></div>
                        <div id="bubble-image_2" style={Layer2()}></div>
                        <div id="bubble-image_3" style={Layer3()}></div>
                    </div>
                </div>
            )
        })
    }


    return (
        <div className="about-page">
            <h3 className="main-button" id="back-button" onClick={props.onClick}>Back</h3>
            <div className="title-card">
                <div className="text">
                    <div className="title-card-heading">
                        <h1 id="title-card-text"><b>Oculus Weather</b></h1>
                        <div id="title-card-body">
                            <h3><i>A minimalist weather visualizer.</i></h3>
                            <br/>
                            <ul>
                                <li><p>temperature initial toggles between celsius and fahrenheit</p></li>
                                <li><p>weather conditions change based on minute data</p></li>
                                <li><p>background theme changes based on time of day</p></li>
                            </ul>
                            
                        </div>
                    </div>
                    
                    <div>
                    <p id="reference">Product Summary
                        <a style={{textDecoration: "none", color: "var(--blue)"}} 
                        href="http://www.edbertcheng.com/oculus-weather.html" 
                        > Here</a>
                    </p>
                    <p id="reference">Weather API from 
                        <a style={{textDecoration: "none", color: "var(--blue)"}} 
                        href="https://openweathermap.org/" 
                        > OpenWeather API</a>
                    </p>
                    <p id="reference">Designed and coded by
                        <a style={{textDecoration: "none", color: "var(--blue)"}} 
                        href="http://www.edbertcheng.com/" 
                        > Edbert Cheng</a>
                    </p>
                    </div>
                </div>

                <div className="image-about">
                    {icons()}
                </div>

            </div>
  
        </div>
    )
}